"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.markMessagesAsReadByClientIdRemotely = exports.markMessagesAsReadRemotely = exports.markMessagesAsReadByClientIdLocally = exports.markMessagesAsReadLocally = exports.markAllMessagesAsReadLocally = exports.MARK_MESSAGES_AS_READ_BY_CLIENT_ID_REMOTELY = exports.MARK_MESSAGES_AS_READ_REMOTELY = exports.MARK_MESSAGES_AS_READ_BY_CLIENT_ID = exports.MARK_ALL_MESSAGES_AS_READ = exports.MARK_MESSAGES_AS_READ = void 0;
exports.MARK_MESSAGES_AS_READ = "MARK_MESSAGES_AS_READ";
exports.MARK_ALL_MESSAGES_AS_READ = "MARK_ALL_MESSAGES_AS_READ";
exports.MARK_MESSAGES_AS_READ_BY_CLIENT_ID = "MARK_MESSAGES_AS_READ_BY_CLIENT_ID";
exports.MARK_MESSAGES_AS_READ_REMOTELY = "MARK_MESSAGES_AS_READ_REMOTELY";
exports.MARK_MESSAGES_AS_READ_BY_CLIENT_ID_REMOTELY = "MARK_MESSAGES_AS_READ_BY_CLIENT_ID_REMOTELY";
function markAllMessagesAsReadLocally(chatId) {
    return {
        type: exports.MARK_ALL_MESSAGES_AS_READ,
        payload: {
            chatId
        }
    };
}
exports.markAllMessagesAsReadLocally = markAllMessagesAsReadLocally;
function markMessagesAsReadLocally(chatId, messageIds) {
    return {
        type: exports.MARK_MESSAGES_AS_READ,
        payload: {
            chatId,
            messageIds
        }
    };
}
exports.markMessagesAsReadLocally = markMessagesAsReadLocally;
function markMessagesAsReadByClientIdLocally(chatId, clientMessageIds) {
    return {
        type: exports.MARK_MESSAGES_AS_READ_BY_CLIENT_ID,
        payload: {
            chatId,
            clientMessageIds
        }
    };
}
exports.markMessagesAsReadByClientIdLocally = markMessagesAsReadByClientIdLocally;
function markMessagesAsReadRemotely(userId, messageIds) {
    return {
        type: exports.MARK_MESSAGES_AS_READ_REMOTELY,
        payload: {
            userId,
            messageIds
        }
    };
}
exports.markMessagesAsReadRemotely = markMessagesAsReadRemotely;
function markMessagesAsReadByClientIdRemotely(userId, clientMessageIds) {
    return {
        type: exports.MARK_MESSAGES_AS_READ_BY_CLIENT_ID_REMOTELY,
        payload: {
            userId,
            clientMessageIds
        }
    };
}
exports.markMessagesAsReadByClientIdRemotely = markMessagesAsReadByClientIdRemotely;
